/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { isEmpty } from "lodash";
import { isArray, isObject, isRichTextNotEmpty } from "utils/empty-exists";

/**
 * Checks if Rich Text is empty. looks to see if the array of paragraphs is 0
 *
 * @param richText
 * @returns {boolean|boolean}
 */
export const isRichTextEmpty = (richText) => {
    const notEmpty = isRichTextNotEmpty(richText);
    return !notEmpty;
};

/**
 * Checks if Rich Text is not empty. looks to see if the array of paragraphs is 0
 *
 * @param richText
 * @returns {boolean|boolean}
 */
export const isRichText = (richText) => {
    if (isObject(richText)) {
        const content = richText?.content;
        if (!content) {
            return false;
        }
        const number = content?.length;
        if (number === 1) {
            const innerContent = content[0]?.content;
            if (isArray(innerContent)) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    }
};

/**
 * Putting this check here since many components will use the same validation.  The
 * first check is for the case where the user has not entered any content.  The second
 * is when the user has entered content but then deleted it all. In this case the content
 * has one empty paragraph.
 *
 * @param richText
 * @returns {boolean|boolean}
 */
export const isRichTextEmptyQuill = (richText) => {
    if (isEmpty(richText)) {
        return true;
    }
    if (richText?.ops?.length === 1 && richText?.ops[0]?.insert === "\n") {
        return true;
    }
    return false;
};
